import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hard work is a total waste of time",
  "description": "",
  "published": "2010-09-22T00:00:00.000Z",
  "redirect_from": ["/blog/hard-work-is-a-total-waste-of-time/swizec/1458"],
  "categories": "AppEngine, Google App Engine, Java, JavaScript, Node.js, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:SteacieLibrary.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/09/300px-SteacieLibrary.jpg",
              "alt": "Steacie Science and Engineering Library at Yor...",
              "title": "Steacie Science and Engineering Library at Yor..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:SteacieLibrary.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Sometimes a series of great decisions can lead to a place where the best decision is a horrendously bad decision.`}</p>
    <p>{`And you just don't realise. Boole algebra taught us early in school that a chain of good implications means the next implication will be pretty good too. Then again, not really. It might be bette to take a step back, look at the bigger bigger picture and make a totally new decision.`}</p>
    <p>{`Very recently, hell, yesterday, this happened to me. Something nudged me from CEO mode into developer mode. To fully analyze this we have to go back to the beginning of this summer when we embarked on The Mission with `}<a parentName="p" {...{
        "href": "http://preona.net/"
      }}>{`Preona`}</a>{` and finally started building `}<a parentName="p" {...{
        "href": "http://lazyreadr.com/"
      }}>{`LazyReadr `}</a>{`after months of promises and figuring out if anyone's interested.`}</p>
    <h3 {...{
      "id": "what-happen"
    }}>{`What happen?`}</h3>
    <p>{`One of the first decisions we made was to run everything on Google's `}<a parentName="p" {...{
        "href": "http://code.google.com/appengine/",
        "title": "Google App Engine"
      }}>{`App Engine`}</a>{`. Mostly because we saw what a pain it was keeping a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Web_service",
        "title": "Web service"
      }}>{`web service`}</a>{` running realiably and we are expecting there to be quite a heavy load when we have to parse a lot of articles and stuff.`}</p>
    <p>{`Then somewhere in the middle of August it was time to start performing proper article `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Web_scraping",
        "title": "Web scraping"
      }}>{`scraping`}</a>{` - taking a link and returning the main text without all the ads and navigation and other crap. After a few attempts with different services ranging from AlchemyAPI to a few different homebrew solutions we decided on Boilerpipe.`}</p>
    <p>{`Boilerpipe is a Java library that does one thing and does it well - it extracts text from links. Great, java, so it runs on AppEngine and does what we need.`}</p>
    <p>{`Fast forward two weeks and we realise that maybe this Boilerpipe thing isn't that great after all. Everything it does is return text. But we need to know when an article has 5 pictures in it, or subtitles, links ... stuff like that.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:NodeJS.png"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/09/300px-NodeJS.png",
              "alt": "The logo of the Node.js Project from the offic...",
              "title": "The logo of the Node.js Project from the offic..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:NodeJS.png"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Since Boilerpipe can't do that and none of our homebrew solutions are good enough at finding content the only place left for us to go was Readability, an `}<a parentName="p" {...{
        "href": "http://www.arc90.com/",
        "title": "Arc90"
      }}>{`Arc90`}</a>{` "experiment", which just happens to be the best content extraction bookmarklet I have ever seen.`}</p>
    <p>{`There's a catch though. It runs on javascript and rewriting all the code into python or java so we can run it server-side just isn't an option. Especially not when it's apparently under active development and we'd have to go to great lengths to keep up.`}</p>
    <p>{`Welcome `}<a parentName="p" {...{
        "href": "http://www.mozilla.org/rhino/",
        "title": "Rhino (JavaScript engine)"
      }}>{`Rhino`}</a>{`. A javasript engine that runs on Java.`}</p>
    <p>{`Welcome Env.js. A fake browser implemented in `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JavaScript",
        "title": "JavaScript"
      }}>{`JavaScript`}</a>{`.`}</p>
    <p>{`Combine the two and voila, we can load up a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Website",
        "title": "Website"
      }}>{`website`}</a>{` into a fake browser running within a fake javascript environment and run readability just like it was in a browser! yay!`}</p>
    <p>{`Well ... no. Stuff didn't work. Env.js was too big for Java. There were bugs. Problems. Lots of stuff. I toiled heavily for three weeks or so until I finally got it working. But by god I got it working!`}</p>
    <p>{`Sure it took me understanding stuff about Env.js internals I never cared about. But I got it working!`}</p>
    <p>{`Exhausted, I deployed the final code onto App Engine.`}</p>
    <p>{`it died`}</p>
    <p>{`The whole website in browser in javascript in java was just too slow. App Engine's 30s restriction was too much and everything just plain old died.`}</p>
    <p>{`Dead end.`}</p>
    <p>{`Effort wasted.`}</p>
    <p>{`But then I started getting an idea. What about `}<a parentName="p" {...{
        "href": "http://nodejs.org/",
        "title": "Node.js"
      }}>{`node.js`}</a>{`? That's javascript. On the server. And it's fast! Surely I can run env.js in there and get everything working right?`}</p>
    <p>{`Not exactly, but there is a project called `}<a parentName="p" {...{
        "href": "http://github.com/tmpvar/jsdom"
      }}>{`jsdom`}</a>{`.`}</p>
    <p>{`Three hours later. Working web scraper. Except now it scrapes huge complex websites in a few seconds!`}</p>
    <p>{`Hoorah! Then a day of patching up jsdom since it's a youngish project and everything doesn't work yet and we have a very sturdy scraper. Whoaw!`}</p>
    <h3 {...{
      "id": "the-lesson-learned"
    }}>{`The lesson learned`}</h3>
    <p>{`expecting high load -> AppEngine -> Java -> Rhino -> Env.js -> not-working-project-and-several-weeks-wasted`}</p>
    <p>{`alternative:`}</p>
    <p>{`node.js -> jsdom -> stuff-works-in-a-day-of-work`}</p>
    <p>{`So I guess what I'm trying to say besides the fact I'm sooper happy I got stuff working, is that I learned my lesson and that I shouldn't base my decisions solely on the previous decisions I've made. Even if all of them were good decisions by themselves.`}</p>
    <p>{`PS: I'm contemplating whether we should make this service public and am leaning heavily on the Yes option. What do you guys think? Need an efficient and good web scraping API?`}</p>
    <h6 {...{
      "id": "related-articles-by-zemanta"
    }}>{`Related articles by Zemanta`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.nodejitsu.com/jsdom-jquery-in-5-lines-on-nodejs"
        }}>{`Using jQuery and node.js to scrape html pages in 5 lines`}</a>{` (nodejitsu.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=4671db4b-1c09-4cc2-9c53-825c17a80c65",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      